import { profileType } from "@utils/enum";
import Exit from "@assets/images/icons/exit_to_app.svg";

export const addToZoho = {
  icon: <Exit />,
  name: "Export to Zoho",
};

export const addToHubspot = {
  icon: <Exit />,
  name: "Export to Hubspot",
};

export const tabDataHandler = [
  {
    name: "Importers-Exporters",
    value: profileType.company,
  },
  {
    name: "Logistics Company",
    value: profileType.logistics,
  },
];

export const logisticsFilters = {
  tagList: [],
  type: [],
};

export const tradeLanesFilters = {
  tagList: [],
};

export let tradeLanesPayload = {
  type: profileType.tradeLanes,
  filters: { ...tradeLanesFilters },
  company_name: "",
  from: 0,
};

export const companyType = {
  import: "I",
  export: "E",
};

export const pendoEventType = {
  tradeLanes: "_trade_lanes_",
};
